import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.css']
})

export class CustomSnackbarComponent implements OnInit {
  @Input() type: 'success' | 'error' | 'info' | 'warning' = 'info';
  @Input() message: string = '';
  @Input() title: string = '';
  @Input() duration: number = 3000;

  isVisible = true;

  ngOnInit() {
    setTimeout(() => {
      this.isVisible = false;
    }, this.duration);
  }

  close() {
    this.isVisible = false;
  }
}